import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './DestinationDetail.scss';
import {Grid} from "@mui/material";

const DestinationDetail = ({destination, reverseOrder, isLast}) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <Grid container spacing={2} style={{
            padding: '0px 100px',
            paddingBottom: '50px',
            borderBottom: isLast ? 'none' : '2px solid #b2afaf', // Conditionally apply borderBottom
            marginBottom: isLast ? '0' : '50px'
        }}>
            {reverseOrder ? (
                <>
                    <Grid item xs={12} md={6}>
                        <div className="description">
                            <h2>{destination.name}</h2>
                            <p>{destination.description}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className="images">
                            <Slider style={{borderRadius: '10px'}} {...settings}>
                                {destination.images.map((image, index) => (
                                    <div key={index}>
                                        <img style={{borderRadius: '10px', width: '475px', height: '280px'}} src={image}
                                             alt="Destination"/>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </Grid>
                </>
            ) : (
                <>
                    <Grid item xs={12} md={6}>
                        <div className="images">
                            <Slider style={{borderRadius: '10px'}} {...settings}>
                                {destination.images.map((image, index) => (
                                    <div key={index}>
                                        <img style={{borderRadius: '10px', width: '475px', height: '280px'}} src={image}
                                             alt="Destination"/>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className="description">
                            <h2>{destination.name}</h2>
                            <p>{destination.description}</p>
                        </div>
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default DestinationDetail;
